import React from 'react';
import styles from './input-with-dropdown.scss';
import commonStyles from '../../pages/add-edit-item/add-edit-item.scss';

const InputWithDropDown = props => {

    const onItemSelect = (e) => {
        props.onItemSelect(e.currentTarget.value);
   }

    const getDropDownOptions = (dropDownList) => {
        let dropDownListArr = [];

        dropDownListArr.push(<option value="" selected disabled hidden></option>);

        dropDownList.forEach(item => {
            let key = item.key ? item.key: item;
            let value = item.label ? item.label: item;
            dropDownListArr.push(
                <option value = {key}>{value}</option>
            )
        });

        return dropDownListArr;
    }
      
    return(
        <>
           <div className={props.containerClass}>
                <div className={`${styles['input-container-dropdown']} ${props.error ? 'error move-up' : ''} ${props.selectedItem ? 'move-up' : ''} ${props.disabled?'disable-div':''}`}>
                    <label className={`${styles['border-label']} ${props.error ? 'error' : ''} ${props.selectedItem || props.error ? commonStyles['font-11'] : commonStyles['font-14']}`}>{props.label}</label>
                    <span className={'icon-pagination-down'}></span>

                    <div>
                        <select id={'select-option'}className={`${styles['select-parent']} ${commonStyles['font-14']}`} value = {props.selectedItem ? props.selectedItem : ""} onChange={(e) => onItemSelect(e)} disabled={props.disabled}>
                            {getDropDownOptions(props.listItems)}
                        </select>
                    </div>
                </div>
                <div className={`${styles['error-msg']} ${props.error ? 'error' : ''} ${commonStyles['font-12']}`}>{props.errorMsg}</div>
           </div>
        </> 
    )
}

export default InputWithDropDown;